import { Flex, Link } from '@iheartjane/reefer';
import { Form, useWatch } from '@iheartjane/reefer-hook-form';
import type { Nullish } from '@iheartjane/types';

import { MaxCharacterHelper } from '../MaxCharacterHelper';
import type { TextFieldName } from './types';

interface LabeledTextFieldProps {
  defaultValue: Nullish<string>;
  label: string;
  maxLength: number;
  multiline?: boolean;
  name: TextFieldName;
  onRevert: () => void;
}

export const LabeledTextField = ({
  defaultValue,
  name,
  label,
  maxLength,
  multiline = false,
  onRevert,
}: LabeledTextFieldProps) => {
  const value = useWatch({ name }) ?? defaultValue;
  // Emphasize the revert link (black) when the value differs from its default.
  const isModified = value !== defaultValue;
  const FieldComponent = multiline ? Form.TextAreaField : Form.TextField;
  return (
    <Flex flexDirection="column" gap={8}>
      <FieldComponent name={name} label={label} maxLength={maxLength} />
      <Flex justifyContent="space-between" alignItems="center">
        <MaxCharacterHelper value={value} maxLength={maxLength} />
        <Link
          onClick={onRevert}
          color={isModified ? 'grays-black' : 'grays-mid'}
          typography="body-regular"
        >
          Revert to default
        </Link>
      </Flex>
    </Flex>
  );
};
